document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleria();
  initVariantes();
  initFaq();
});

/* Animación de entrada al hacer scroll, compartida por toda la web */
function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          var el = entry.target;
          setTimeout(function () { el.classList.add('mt-visible'); }, (el.dataset.mtDelay || 0) * 1);
          observer.unobserve(el);
        }
      });
    },
    { threshold: 0.01, rootMargin: '0px 0px -30px 0px' }
  );
  els.forEach(function (el, i) {
    el.dataset.mtDelay = (i % 6) * 70;
    observer.observe(el);
  });
}

/* Cambia el src de una imagen con un pequeño fundido, en vez de un salto seco */
function cambiarFotoConTransicion(img, nuevoSrc) {
  if (!img || !nuevoSrc || img.getAttribute('src') === nuevoSrc) return;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    img.src = nuevoSrc;
    return;
  }
  img.classList.add('mt-foto-cambiando');
  window.setTimeout(function () {
    img.src = nuevoSrc;
    img.classList.remove('mt-foto-cambiando');
  }, 220);
}

/* Galería de producto: click en miniatura, flechas en pantalla y flechas del
   teclado (en ordenador) cambian la imagen principal. La tira de miniaturas
   sigue siendo la "barra" que se desplaza, solo que sin el scrollbar visible. */
function initGaleria() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-imagen-principal]');
    var miniaturas = Array.prototype.slice.call(galeria.querySelectorAll('[data-mt-miniatura]'));
    var flechaPrev = galeria.querySelector('[data-mt-galeria-prev]');
    var flechaNext = galeria.querySelector('[data-mt-galeria-next]');
    if (!principal || !miniaturas.length) return;

    function irA(indice) {
      var total = miniaturas.length;
      var destino = ((indice % total) + total) % total;
      var min = miniaturas[destino];
      var src = min.getAttribute('data-mt-src');
      if (!src) return;
      cambiarFotoConTransicion(principal, src);
      miniaturas.forEach(function (m) { m.classList.remove('mt-activa'); });
      min.classList.add('mt-activa');
      min.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }

    function indiceActual() {
      var i = miniaturas.findIndex(function (m) { return m.classList.contains('mt-activa'); });
      return i === -1 ? 0 : i;
    }

    miniaturas.forEach(function (min, i) {
      min.addEventListener('click', function () { irA(i); });
    });

    if (flechaPrev) flechaPrev.addEventListener('click', function () { irA(indiceActual() - 1); });
    if (flechaNext) flechaNext.addEventListener('click', function () { irA(indiceActual() + 1); });

    if (miniaturas.length > 1) {
      galeria.addEventListener('keydown', function (e) {
        var etiqueta = document.activeElement ? document.activeElement.tagName : '';
        if (etiqueta === 'INPUT' || etiqueta === 'TEXTAREA' || etiqueta === 'SELECT') return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); irA(indiceActual() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); irA(indiceActual() + 1); }
      });
    }
  });
}

/* Selector de variantes: actualiza precio, id del formulario y estado agotado */
function initVariantes() {
  document.querySelectorAll('[data-mt-producto-form]').forEach(function (wrap) {
    var dataEl = wrap.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = wrap.querySelector('[data-mt-variant-id]');
    var precioActual = wrap.querySelector('[data-mt-precio-actual]');
    var precioAntes = wrap.querySelector('[data-mt-precio-antes]');
    var botonComprar = wrap.querySelector('[data-mt-boton-comprar]');
    var avisoAgotado = wrap.querySelector('[data-mt-agotado]');
    var pildoras = wrap.querySelectorAll('[data-mt-pildora]');
    var seccion = wrap.closest('.mt-producto-grid') || wrap.parentElement;
    var imagenPrincipal = seccion && seccion.querySelector('[data-mt-imagen-principal]');

    function seleccionActual() {
      var elegido = {};
      wrap.querySelectorAll('[data-mt-pildora].mt-activa').forEach(function (p) {
        elegido[p.getAttribute('data-mt-opcion')] = p.getAttribute('data-mt-valor');
      });
      return elegido;
    }

    function formatoMoneda(centavos) {
      var formato = window.mtMoneyFormat || '€{{amount}}';
      var unidades = (centavos / 100).toFixed(2).split('.');
      var conComas = unidades[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + unidades[1];
      var sinDecimales = unidades[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var conPunto = unidades.join('.');
      return formato
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComas)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, sinDecimales)
        .replace(/\{\{\s*amount\s*\}\}/, conPunto);
    }

    function actualizar() {
      var elegido = seleccionActual();
      var variante = variantes.find(function (v) {
        return Object.keys(elegido).every(function (k) { return v.opciones[k] === elegido[k]; });
      });
      if (!variante) return;

      idInput.value = variante.id;
      if (precioActual) precioActual.textContent = formatoMoneda(variante.price);
      if (precioAntes) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntes.textContent = formatoMoneda(variante.compare_at_price);
          precioAntes.style.display = '';
        } else {
          precioAntes.style.display = 'none';
        }
      }
      if (botonComprar) {
        botonComprar.disabled = !variante.available;
        botonComprar.querySelector('[data-mt-texto-boton]').textContent = variante.available
          ? botonComprar.getAttribute('data-mt-texto-disponible')
          : botonComprar.getAttribute('data-mt-texto-agotado');
      }
      if (avisoAgotado) avisoAgotado.style.display = variante.available ? 'none' : '';
      if (imagenPrincipal && variante.imagen) cambiarFotoConTransicion(imagenPrincipal, variante.imagen);
    }

    pildoras.forEach(function (p) {
      p.addEventListener('click', function () {
        if (p.disabled) return;
        var grupo = p.getAttribute('data-mt-opcion');
        wrap.querySelectorAll('[data-mt-opcion="' + grupo + '"]').forEach(function (h) { h.classList.remove('mt-activa'); });
        p.classList.add('mt-activa');
        actualizar();
      });
    });

    actualizar();
  });
}

/* FAQ desplegable, accesible */
function initFaq() {
  document.querySelectorAll('.mt-faq-item').forEach(function (item) {
    var pregunta = item.querySelector('.mt-faq-pregunta');
    var respuesta = item.querySelector('.mt-faq-respuesta');
    if (!pregunta || !respuesta) return;
    pregunta.addEventListener('click', function () {
      var abierta = item.classList.contains('mt-abierta');
      item.parentElement.querySelectorAll('.mt-faq-item').forEach(function (otro) {
        otro.classList.remove('mt-abierta');
        otro.querySelector('.mt-faq-respuesta').style.maxHeight = null;
        otro.querySelector('.mt-faq-pregunta').setAttribute('aria-expanded', 'false');
      });
      if (!abierta) {
        item.classList.add('mt-abierta');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
        pregunta.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/* Menú de escritorio: el desplegable se abre al pasar el ratón, y al hacer
   clic en el apartado padre (p. ej. "Shop") se va a su página con todos los
   productos en vez de limitarse a abrir el desplegable.
   En móvil no se toca nada: allí el clic sigue abriendo el submenú. */
function initMenuEscritorio() {
  var anchas = window.matchMedia('(min-width: 990px)');
  var menus = document.querySelectorAll('.header__inline-menu header-menu > details');
  if (!menus.length) return;

  Array.prototype.forEach.call(menus, function (detalle) {
    var titulo = detalle.querySelector('summary');
    if (!titulo) return;
    var destino = titulo.dataset.mtUrl;
    var cerrar;

    detalle.addEventListener('mouseenter', function () {
      if (!anchas.matches) return;
      window.clearTimeout(cerrar);
      detalle.setAttribute('open', '');
    });

    detalle.addEventListener('mouseleave', function () {
      if (!anchas.matches) return;
      cerrar = window.setTimeout(function () {
        detalle.removeAttribute('open');
      }, 180);
    });

    titulo.addEventListener('click', function (e) {
      if (!anchas.matches || !destino || destino === '#') return;
      e.preventDefault();
      window.location.href = destino;
    });
  });
}

document.addEventListener('DOMContentLoaded', initMenuEscritorio);
